import React from "react";
import { useMask } from "@react-input/mask";

const Expiration = ({
  placeholder,
  error,
  name,
  type,
  width,
  value,
  margin,
  handleChange,
  icon,
  max,
  comment,
  trigger,
  dataTestId,
}) => {
  const inputRef = useMask({ mask: "__/__", replacement: { _: /\d/ } });
  const isEnhancedContrast = window.enhancedContrast;

  return (
    <div
      className="input-container"
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginInlineEnd: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div
        className={`input input--text ${error && "input--error"} ${isEnhancedContrast && "enhancedContrast"} ${isEnhancedContrast && error && "enhancedContrast__error"}`}
      >
        <input
          data-testid={dataTestId}
          ref={inputRef}
          maxLength={max}
          className="styledInput"
          type={type}
          name={name}
          autoComplete="cc-exp"
          value={value}
          onBlur={() => {
            trigger(["card_exp_year", "card_exp_month"]);
          }}
          onChange={handleChange}
        />
        <label
          className={`styledLabel ${value?.length > 0 && "styledLabel--active"} ${isEnhancedContrast && "styledLabel__enhancedContrast"}`}
        >
          {placeholder}
        </label>
        {icon && (
          <div
            className="input__img"
            style={{
              backgroundImage: `url(${icon}`,
            }}
          >
            {comment && <span className="input__comment">{comment}</span>}
          </div>
        )}
      </div>
      {error && <span className="formError">{error}</span>}
    </div>
  );
};

export default Expiration;
